// // src/data/pharmacistMockData.js

// export const prescriptionMockData = [{
//         id: 1,
//         patient: 'John Doe',
//         medication: 'Sertraline',
//         doctor: 'Dr. Arvind Kumar',
//         status: 'Pending',
//     },
//     {
//         id: 2,
//         patient: 'Jane Smith',
//         medication: 'Lorazepam',
//         doctor: 'Dr. Suresh Choudhury',
//         status: 'Approved',
//     },
//     {
//         id: 3,
//         patient: 'Emily Davis',
//         medication: 'Fluoxetine',
//         doctor: 'Dr. Dipankar Deka',
//         status: 'Pending',
//     },
//     {
//         id: 4,
//         patient: 'Michael Brown',
//         medication: 'Quetiapine',
//         doctor: 'Dr. Suresh Choudhury',
//         status: 'Declined',
//     },
// ];

// export const inventoryMockData = [{
//         id: 1,
//         name: 'Sertraline',
//         stock: 5,
//         recentRestock: '2023-09-01',
//     },
//     {
//         id: 2,
//         name: 'Lorazepam',
//         stock: 15,
//         recentRestock: '2023-08-28',
//     },
//     {
//         id: 3,
//         name: 'Fluoxetine',
//         stock: 8,
//         recentRestock: '2023-08-25',
//     },
//     {
//         id: 4,
//         name: 'Quetiapine',
//         stock: 3,
//         recentRestock: '2023-09-02',
//     },
// ];

// src/data/pharmacistMockData.js

export const prescriptionMockData = [
  {
    id: 1,
    patient: 'John Doe',
    medication: 'Sertraline',
    doctor: 'Dr. Arvind Kumar',
    status: 'Pending',
  },
  {
    id: 2,
    patient: 'Jane Smith',
    medication: 'Lorazepam',
    doctor: 'Dr. Suresh Choudhury',
    status: 'Pending',
  },
  {
    id: 3,
    patient: 'Emily Davis',
    medication: 'Fluoxetine',
    doctor: 'Dr. Dipankar Deka',
    status: 'Filled',
  },
];

export const inventoryMockData = [
  {
    id: 1,
    name: 'Sertraline',
    stock: 5,
    expiry: '2024-05-12',
    reordering: false,
  },
  {
    id: 2,
    name: 'Lorazepam',
    stock: 3,
    expiry: '2023-10-01',
    reordering: false,
  },
  {
    id: 3,
    name: 'Fluoxetine',
    stock: 8,
    expiry: '2025-02-15',
    reordering: false,
  },
];

export const pharmacyMetricsMockData = [
  {
    title: 'Prescriptions Filled Today',
    value: 15,
    description: 'Number of prescriptions filled today',
  },
  {
    title: 'Low Stock Medications',
    value: 2,
    description: 'Medications with critically low stock',
  },
  {
    title: 'Medication Usage This Month',
    value: '350 units',
    description: 'Total medication usage this month',
  },
];
